import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.98408 5.01611L15.1949 8.57344V15.6881L8.98408 19.2454L2.77331 15.6881V8.57344L8.98408 5.01611Z",
			fill: "#EEA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1888 9.75391V10.6551H11.7654V13.6229H12.1888V14.5241H10.3379V13.6229H10.7682V10.6551H10.3379V9.75391H12.1888Z",
			fill: "#0D26BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.88477 14.5241L6.88598 9.75391H7.93781L9.93902 14.5241H8.90085L8.44324 13.4196H6.38738L5.92977 14.5241H4.88477ZM6.76304 12.5185H8.06758L7.4119 10.9532L6.76304 12.5185Z",
			fill: "#0D26BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.37037 2.6113C2.49714 2.38063 2.82858 2.38063 2.95535 2.6113L3.37871 3.38161C3.40959 3.43781 3.45601 3.48392 3.51241 3.51442L4.28299 3.93123C4.51628 4.05741 4.51628 4.39217 4.28299 4.51835L3.51241 4.93516C3.45601 4.96567 3.40959 5.01178 3.37871 5.06797L2.95535 5.83828C2.82858 6.06895 2.49714 6.06895 2.37037 5.83828L1.94701 5.06797C1.91613 5.01178 1.86971 4.96567 1.81331 4.93516L1.04273 4.51835C0.80944 4.39217 0.80944 4.05742 1.04273 3.93123L1.81331 3.51442C1.86971 3.48392 1.91613 3.43781 1.94701 3.38161L2.37037 2.6113Z",
			fill: "#EEA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.57092 0.702128C3.67234 0.51759 3.93749 0.51759 4.03891 0.702128L4.2089 1.01142C4.2336 1.05638 4.27074 1.09327 4.31586 1.11767L4.62291 1.28376C4.80954 1.38471 4.80954 1.65251 4.62291 1.75346L4.31586 1.91954C4.27074 1.94395 4.2336 1.98084 4.2089 2.02579L4.03891 2.33509C3.93749 2.51963 3.67234 2.51963 3.57092 2.33509L3.40094 2.02579C3.37623 1.98084 3.33909 1.94395 3.29397 1.91954L2.98692 1.75346C2.80029 1.65251 2.80029 1.38471 2.98692 1.28376L3.29397 1.11767C3.33909 1.09327 3.37623 1.05638 3.40094 1.01142L3.57092 0.702128Z",
			fill: "#EEA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.06601 2.07274C1.11672 1.98047 1.24929 1.98047 1.3 2.07274L1.40508 2.26393C1.41743 2.28641 1.436 2.30486 1.45856 2.31706L1.64892 2.42002C1.74224 2.4705 1.74224 2.6044 1.64892 2.65487L1.45856 2.75784C1.436 2.77004 1.41743 2.78849 1.40508 2.81097L1.3 3.00216C1.24929 3.09442 1.11672 3.09442 1.06601 3.00216L0.960935 2.81097C0.948581 2.78849 0.930013 2.77004 0.907453 2.75784L0.717092 2.65487C0.623776 2.6044 0.623776 2.4705 0.717092 2.42002L0.907453 2.31706C0.930013 2.30486 0.948581 2.28641 0.960935 2.26393L1.06601 2.07274Z",
			fill: "#EEA6FF"
		})
	]
});
export default SvgAi;
